module.exports = __webpack_public_path__ + "img/svg - only fam.171f5805.svg";